export default "__VITE_ASSET__CGWwZyUK__"